import { z } from 'zod';

export const RecordMeetingJobSchema = z.object({
  recordingId: z.string(),
  meetingUrl: z.string().url(),
  meetingName: z.string().optional(),
  scheduledStartDate: z.number().optional(), // Timestamp of scheduled meeting start time
});

export type RecordMeetingJob = z.infer<typeof RecordMeetingJobSchema>;
